import React, { useState } from "react";

import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from "@mui/material/IconButton";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

export interface IconButtonProps extends MuiIconButtonProps {
  tooltip?: string;
  tooltipPlacement?: TooltipProps["placement"];
}

export const IconButton: React.FC<IconButtonProps> = ({
  children,
  className,
  tooltip,
  tooltipPlacement = "top",
  ...props
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const button = (
    <MuiIconButton
      sx={(theme) => ({
        width: theme.spacing(5),
        height: theme.spacing(5),
        border: `1px solid ${theme.palette.grey[200]}`,
      })}
      {...props}>
      {children}
    </MuiIconButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip open={isTooltipOpen} placement={tooltipPlacement} title={tooltip}>
      <Box
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}>
        {button}
      </Box>
    </Tooltip>
  );
};

export default IconButton;
